import styled from 'styled-components'
import media from 'utils/media'
import { Link } from 'components/Common'
import { Col } from 'components/Grid'

export const EventContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  margin-bottom: 62px;
`
export const StyledLink = styled(Link)`
color: #fff !important;
padding: 0!important;
margin-top: 45px;
`
export const EventStaticElemen = styled.div`
  background-color: ${({ theme }) => theme.colors.blueDark};
  padding: 57px 46px 56px 41px;
  color: #ffffff;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
  height: 389px;
  margin-bottom: 39px;
  ${media.greaterThan('md')`  
    padding: 105px 124px 76px 97px;
    height: 593px;
`}
h5 {
  font-size: 20px;
  margin-bottom: 23px;
  ${media.greaterThan('md')`  
    font-size: 24px;
    margin-bottom: 48px;
  `}
}
p {
  margin-bottom: 0;
  ${media.greaterThan('md')`  
    margin-bottom: 45px;
  `}
}
`
export const EventsCol = styled(Col)`
  padding: 0 50px;
  ${media.greaterThan('1216px')`  
    padding: 0 103px;
  `}
`
